/**
 * Created: 2026-04-07
 * Initial commit: Add UserAvatar component for consistent user display
 *
 * Displays user avatar image with name, optional mobile, and gender icon.
 */

import FemaleIcon from '@mui/icons-material/Female'
import MaleIcon from '@mui/icons-material/Male'
import { Avatar, Box, Typography } from '@mui/material'
import { getImageUrl } from '../config'
import { Gender } from '../gql/graphql'

interface UserAvatarUser {
  name?: string | null
  avatar?: string | null
  mobile?: string | null
  // Widened to also accept @tc-app/shared/event's plain string-literal union, since
  // the event plan view renders players built by `buildMatch()`.
  gender?: Gender | 'FEMALE' | 'MALE' | 'OTHER' | null
}

interface UserAvatarProps {
  user: UserAvatarUser
  showGender?: boolean
  showMobile?: boolean
}

export default function UserAvatar({
  user,
  showGender = true,
  showMobile = true,
}: UserAvatarProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Avatar
        src={user.avatar ? getImageUrl(user.avatar) : undefined}
        sx={{ width: 28, height: 28 }}
      />
      <div>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Typography variant="body2" component="span">
            {user.name ?? '-'}
          </Typography>
          {showGender && user.gender === Gender.Male && (
            <MaleIcon sx={{ fontSize: '1rem', color: '#1989fa' }} />
          )}
          {showGender && user.gender === Gender.Female && (
            <FemaleIcon sx={{ fontSize: '1rem', color: '#ff6b9d' }} />
          )}
        </Box>
        {showMobile && user.mobile && (
          <Typography
            variant="caption"
            sx={{
              color: 'text.secondary',
              display: 'block',
            }}
          >
            {user.mobile}
          </Typography>
        )}
      </div>
    </Box>
  )
}
